<template>
  <div class="p-grid" style="text-align: center">
    <div class="p-col-12 p-mt-5">
      <h1>Loading...</h1>
    </div>
    <div class="p-col-12 p-mt-5">
      <img src="/countdown.gif" style="height: 50vh;width: 50vw">
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import _ from 'lodash';

export default {
  name: "Splash",
  methods: {
    ...mapActions("config", ["loadConfiguration"]),
    ...mapActions("auth", ['setLogin']),
    checkConfiguration() {
      switch (this.authType) {
        case "DEMO":
          this.demoLogin();
          break;
        case "KERBEROS":
          this.kerberosLogin();
          break;
        case "KEYCLOAK":
          this.keycloakLogin();
          break;
      }
    },
    kerberosLogin() {
      let userInfo = this.userInfo;
      if (_.get(userInfo, "loggedIn", false) === true) {
        this.setLogin({username: userInfo.username, roles: userInfo.roles})
        this.$router.push('/');
      } else {
        this.$router.push('/signin');
      }
    },
    demoLogin() {
      let userInfo = this.userInfo;
      if (_.get(userInfo, "loggedIn", false) === true) {
        this.setLogin({username: userInfo.username, roles: userInfo.roles})
        this.$router.push('/');
      } else {
        this.$router.push('/signin');
      }
    },
    keycloakLogin() {
      let userInfo = this.userInfo;
      console.log("userInfo", userInfo);
      if (_.get(userInfo, "loggedIn", false) === true) {
        if (userInfo.roles.length === 0) {
          this.$router.push('/denied');
        } else {
          this.setLogin({username: userInfo.username, roles: userInfo.roles})
          this.$router.push('/');
        }
      } else {
        this.$router.push('/error');
      }
    }
  },
  computed: {
    ...mapGetters('config', ['authType', 'userInfo'])
  },
  mounted() {
    this.loadConfiguration().then(() => {
      this.checkConfiguration();
    }).catch(() => {
      this.$router.push('/error')
    })
  }
}
</script>

<style scoped>

</style>